import type { Question } from '../services/questions/types'

export const enum CategoryKeys {
	delivery = 'delivery',
	productInfo = 'productInfo',
	returns = 'returns',
	loyalty = 'loyalty',
	payments = 'payments',
}

export const enum QuestionsKeys {
	changeAddress = 'changeAddress',
	cancelOrder = 'cancelOrder',
	garmentCare = 'garmentCare',
	orderStatus = 'orderStatus',
	returnsStatus = 'returnsStatus',
	refunds = 'refunds',
	checkLikes = 'checkLikes',
	orderIncomplete = 'orderIncomplete',
	loyalty = 'loyalty',
	discoverClub = 'discoverClub',
	getLikes = 'getLikes',
	useLikes = 'useLikes',
	benefits = 'benefits',
	birthdayGift = 'birthdayGift',
	useGiftCard = 'useGiftCard',
	paymentMethods = 'paymentMethods',
	sizeGuide = 'sizeGuide',
	tiers = 'tiers',
}

export type QuestionIDType = {
	categoryKey: CategoryKeys
	questionKey: QuestionsKeys
}

export type GetQuestionResponse = {
	question: {
		categoryKey: string
		key: string
		title: string
		isSustainable: boolean
	}
	answers: {
		text: string
		buttons: {
			label: string
			actions: {}
			href: {
				linkAttr: string
				loggedLinkAttr: string
			}
			target: string | undefined
			rel: string | null
			key: string
		}[]
		indexKey: number
	}[]
	relatedQuestions: Question[]
}
